import { MaskedLine } from "./Reveal";

export const PageHero = ({ image, imageAlt, kicker, title, titleAccent, sub, testidPrefix }) => (
    <section className="relative overflow-hidden xp-grain" data-testid={`${testidPrefix}-hero`}>
        <div className="absolute inset-0">
            <img src={image} alt={imageAlt} className="w-full h-full object-cover" loading="eager" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-[#07080B]" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-40 pb-20">
            <p className="font-mono-xp text-[11px] uppercase tracking-[0.3em] text-[#E53E3E] mb-5">{kicker}</p>
            <h1 className="font-display uppercase font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-white max-w-4xl" data-testid={`${testidPrefix}-title`}>
                <MaskedLine delay={0.1}>{title}</MaskedLine>
                {titleAccent && (
                    <MaskedLine delay={0.25} className="text-[#E53E3E]">
                        {titleAccent}
                    </MaskedLine>
                )}
            </h1>
            {sub && <p className="text-gray-300 text-sm sm:text-base leading-relaxed mt-6 max-w-2xl">{sub}</p>}
        </div>
    </section>
);
